import React, {useCallback, useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {TitledBody} from '../../common/components/TitledBody'
import {useFetchData} from '../../common/servercall/useFetchData'
import {useParams} from 'react-router'
import {api} from '../../common/api'
import {useSelector} from 'react-redux'
import {selectedSiteSelector} from '../../authentication/redux'
import {Page} from '../../app/navigation/redux'
import {Supervisor} from "../../app/types";
import {Grid} from "@mui/material";
import {SectionedForm} from "../../common/components/SectionedForm";
import {useGeneralSection} from "./sections/general";
import {useAccessHelpers} from "../../common/util/hooks";

export const DetailSupervisor = () => {
    const { t } = useTranslation()
    const { id }: { id: string } = useParams()
    const site = useSelector(selectedSiteSelector)
    const {hasWriteAccess} = useAccessHelpers()
    const fetchSupervisor = useCallback(
        async (supervisorId: string): Promise<Supervisor | undefined> => {
            if (!site) return
            const { data } = await api.get<Supervisor>(`/api/site/${site.productId}/business-reporting/supervisors/${supervisorId}`)
            return data
        },
        [site]
    )

    const { data, isFetching, error, refetch } = useFetchData<Supervisor>(useCallback(() => fetchSupervisor(id), [fetchSupervisor, id]))

    const pageInfo: Page | null = useMemo(
        () =>
            data
                ? {
                      label: `${data.userLastName} ${data.userFirstName}`,
                      key: 'supervisor-detail',
                  }
                : null,
        [data]
    )

    const generalSection = useGeneralSection(id, isFetching, error, refetch, data);
    const formSections = useMemo(() => [
        generalSection
    ], [generalSection])

    return (
        <TitledBody title={t('supervisors.supervisor')} page={pageInfo}>
            <Grid container>
                <Grid item xs={12} lg={10}>
                    <SectionedForm activeTab={0} formSections={formSections} readOnly={!hasWriteAccess}/>
                </Grid>
            </Grid>
        </TitledBody>
    )
}
